import { render, staticRenderFns } from "./RoutePlanner.vue?vue&type=template&id=0f87545f&scoped=true&lang=pug&"
import script from "./RoutePlanner.vue?vue&type=script&lang=js&"
export * from "./RoutePlanner.vue?vue&type=script&lang=js&"
import style0 from "./RoutePlanner.vue?vue&type=style&index=0&id=0f87545f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87545f",
  null
  
)

export default component.exports